import { Grid } from "@mui/material";
import { GridItem } from "Components/Shared/GridItem";
import { FormSection } from "Components/Shared/FormSection";
import type { BankVerificationSource } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";

const FORM_RESOURCES =
  Resources.Pages.Content.UserDetailPageContent.Tabs.User.Form;

type Props = {
  bankVerificationSource?: BankVerificationSource | null;
  verifiedIBAN?: string | null;
};

export const BankSection = ({
  bankVerificationSource,
  verifiedIBAN,
}: Props) => {
  const { t } = useResource();

  return (
    <FormSection legend={t(FORM_RESOURCES.Legend.Bank)} noMargins>
      <Grid container spacing={2}>
        <GridItem
          columns={2}
          label={t(FORM_RESOURCES.BankVerificationSource)}
          value={
            bankVerificationSource
              ? t(Resources.Form.BankVerificationSource[bankVerificationSource])
              : undefined
          }
        />
        <GridItem
          columns={2}
          label={t(FORM_RESOURCES.BankAccountNumber)}
          value={verifiedIBAN}
        />
      </Grid>
    </FormSection>
  );
};
